const RadioField = ({ label, name, value, onChange, options = [] }) => {
  return (
    <div className="w-full pt-2">
      {label && (
        <label className="block text-base sm:text-lg font-semibold text-text-primary mb-3 font-poppins">
          {label}
        </label>
      )}
      {/* <div className="flex items-center gap-6 p-3 border border-border rounded-lg bg-white flex-wrap"> */}
      <div className="grid grid-cols-1 sm:grid-cols-2 items-center gap-4  rounded-lg bg-white flex-wrap">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center gap-2 cursor-pointer"
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange && onChange(option.value)}
              className="w-4 h-4 accent-primary cursor-pointer"
            />
            <span className="text-text-secondary text-sm font-medium">
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioField;
